import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_PERSONAL = "GET_PERSONAL";
export const GET_ALL_TIPOS_WFH = "GET_ALL_TIPOS_WFH";
export const GET_ALL_EDIFICIOS = "GET_ALL_EDIFICIOS";
export const GET_PROFESIONALES_SITIOS = "GET_PROFESIONALES_SITIOS";
export const GET_HORARIOS_PROFESIONAL = "GET_HORARIOS_PROFESIONAL";
export const ADD_APPOINTMENT = "ADD_APPOINTMENT";
export const CANCEL_APPOINTMENT = "CANCEL_APPOINTMENT";
export const GET_APPOINTMENT = "GET_APPOINTMENT";
export const MEA_LOADING = "MEA_LOADING";
export const MEA_PRUEBA = "MEA_PRUEBA";
export const GET_APPOINTMENT_BY_STATE = "GET_APPOINTMENT_BY_STATE";
export const GET_DIAGNOSTICOS = "GET_DIAGNOSTICOS";

export const GET_ES_DOCTOR = "GET_ES_DOCTOR";
export const GET_ES_PUESTO = "GET_ES_PUESTO";
export const GET_HEALTH_CAMPAIGN = "GET_HEALTH_CAMPAIGN";
export const GET_ALL_HEALTH_CAMPAIGN = "GET_ALL_HEALTH_CAMPAIGN";
export const ADD_HEALTH_CAMPAIGN = "ADD_HEALTH_CAMPAIGN";
export const UPDATE_HEALTH_CAMPAIGN = "UPDATE_HEALTH_CAMPAIGN";
export const DELETE_HEALTH_CAMPAIGN = "DELETE_HEALTH_CAMPAIGN";
export const MEA_ADD_IMAGE = "MEA_ADD_IMAGE";
export const MEA_GET_IMAGE = "MEA_GET_IMAGE";
export const GET_IMAGES_HEALTH_CAMPAIGN = "GET_IMAGES_HEALTH_CAMPAIGN";

export const MEA_GET_BUILDING = "MEA_GET_BUILDING";
export const MEA_GET_REQUEST_TYPE = "MEA_GET_REQUEST_TYPE";
export const MEA_GET_EMPLOYEES_SIIS = "MEA_GET_EMPLOYEES_SIIS";
export const MEA_ADD_SELF_MANAGEMENT = "MEA_ADD_SELF_MANAGEMENT";
export const MEA_ALL_SELF_MANAGEMENTS = "MEA_GET_SELF_MANAGEMENTS";
export const MEA_GET_SELF_MANAGEMENT = "MEA_GET_SELF_MANAGEMENT"; 
export const MEA_GET_AREA_CUENTA = "MEA_GET_AREA_CUENTA";
export const MEA_SEND_EMAIL = "MEA_SEND_EMAIL";
export const MEA_UPDATE_SELF_APPOIMENT = "MEA_UPDATE_SELF_APPOIMENT";
export const MEA_HABILITAR_CITA = "MEA_HABILITAR_CITA";
export const MEA_HABILITAR_CITA_AUTOGESTION = "MEA_HABILITAR_CITA_AUTOGESTION";
export const MEA_UPDATE_OPEN_BUILDING = "MEA_UPDATE_OPEN_BUILDING";
export const MEA_GET_ONE_EMPLOYEE_SIIS = "MEA_GET_ONE_EMPLOYEE_SIIS";

const instance = axios.create({
  baseURL: process.env.REACT_APP_AYB_API_SIIS_URL,
  withCredentials: false,
  headers: {
    "Accept": "*/*",
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});

function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [month, day, year].join('/');
  }
export const getPersonalByBadge = (badge) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Personal?identificacion=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_PERSONAL,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const getAllEdificios = () => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Edificios?token=${Token}`).then((res => {
          dispatch({
              type: GET_ALL_EDIFICIOS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const getAllTipoAtencionWFH = () => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Citas?token=${Token}`).then((res => {
          dispatch({
              type: GET_ALL_TIPOS_WFH,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const getProfecionalesBySitios = (sitio) => {
    var Token = convertSHA();
    var Fecha = formatDate(Date.now());
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Profesionales?fecha=${Fecha}&identificacion&sitio=${sitio}&token=${Token}`).then((res => {
          dispatch({
              type: GET_PROFESIONALES_SITIOS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const getHorariosByProfecional = (sitio,profesional) => {
    var Token = convertSHA();
    var Fecha = formatDate(Date.now());
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/HorarioDisponible?fecha=${Fecha}&ID_Profesional=${profesional}&identificacion&sitio=${sitio}&token=${Token}`).then((res => {
          dispatch({
              type: GET_HORARIOS_PROFESIONAL,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const getCitasByBadge = (badge,profesional) => {
    var Token = convertSHA();
    var Fecha = formatDate(Date.now());
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Citas?identificacion=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_APPOINTMENT,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const addAppointment = (idColaborador, idProfesional, HoraI, HoraF, isSitio) =>{
    var Token = convertSHA()
    var Fecha = formatDate(Date.now());
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          //console.log(data)
          //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
          await instance.post(`/HorarioDisponible?ID_Colaborador=${idColaborador}&ID_Profesional=${idProfesional}&Fecha=${Fecha}
                                &Hora=${HoraI}&HoraFinal=${HoraF}&sitio=${isSitio}&token=${Token}` ).then((res => {
              dispatch({
                  type: ADD_APPOINTMENT,
                  data: res.data
                  
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  }
  export const addAppointmentWFH = (idColaborador, idProfesional, HoraI, HoraF, isSitio, tipoWFH, motivo, tel1, tel2) =>{
    var Token = convertSHA()
    var Fecha = formatDate(Date.now());
    if(tel1==''){
      tel1='00000000'
    }
    if(tel2==''){
      tel2='00000000'
    }
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          //console.log(data)
          //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
          await instance.post(`/HorarioDisponibleWFH?ID_Colaborador=${idColaborador}&ID_Profesional=${idProfesional}&Fecha=${Fecha}
                                &Hora=${HoraI}&HoraFinal=${HoraF}&sitio=${isSitio}&TipoSolicitud=${tipoWFH}
                                &Motivo=${motivo}&tel1=${tel1}&tel2=${tel2}&token=${Token}` ).then((res => {
              dispatch({
                  type: ADD_APPOINTMENT,
                  data: res.data
                  
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  }
  export const cancelAppointment = (badge, fecha, hora) =>{
    var Token = convertSHA()
    fecha = formatDate(fecha)
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          //console.log(data)
          //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
          await instance.get(`/Citas?fecha=${fecha}&hora=${hora}&identificacion=${badge}&token=${Token}` ).then((res => {
              dispatch({
                  type: ADD_APPOINTMENT,
                  data: res.data
                  
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  }
 
  export const getCitasFiltroPorEstado = (badge,estado) => {
    var Token = convertSHA();
    var Fecha = formatDate(Date.now());
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Citas?identificacion=${badge}&estado=${estado}&token=${Token}`).then((res => {
          dispatch({
              type: GET_APPOINTMENT_BY_STATE,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
 
  export const getHistorialDiagnosticos = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/diagnosticos/getHistorialDiagnosticos?identificacion=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_DIAGNOSTICOS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getEsDoctor = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/HealthCampaigns?badge=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_ES_DOCTOR,
              data: res.data
              });
        //console.log("Es un doctor, respuesta de API ", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getEsPuesto = (badge,puesto) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Personal?badge=${badge}&puesto=${puesto}&token=${Token}`).then((res => {
          dispatch({
              type: GET_ES_PUESTO,
              data: res.data
              });
        //console.log("El puesto "+puesto+" es ", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };


  export const getAllHealthCampaigns = (obtenerTodos) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/HealthCampaigns?token=${Token}&obtenerTodos=true`).then((res => {
          dispatch({
              type: GET_ALL_HEALTH_CAMPAIGN,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getImagesHealthCampaigns = (obtenerTodos) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/HealthCampaigns?token=${Token}`).then((res => {
          dispatch({
              type: GET_IMAGES_HEALTH_CAMPAIGN,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getHealthCampaign = (id) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/HealthCampaigns${id}?token=${Token}`).then((res => {
          dispatch({
              type: GET_ALL_HEALTH_CAMPAIGN,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };



  export const addHealthCampaigns = (nombre, ruta,activo, prioridad, fechaInicio, fechaFin, badge, image) =>{
    var Token = convertSHA()
    const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
    let formData = new FormData();
  
    if (image == '') {
      image = '-1'
    }
    else {
      formData.append('image', image);
    }
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            }); 
          await instance.post(`/HealthCampaigns?token=${Token}&nombre=${nombre}&ruta=${ruta}
                                          &prioridad=${prioridad}&activo=${activo}
                                          &fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&badge=${badge}` , formData, config).then((res => {
              dispatch({
                  type: ADD_HEALTH_CAMPAIGN,
                  data: res.data
                  
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  }

  export const updateHealthCampaigns = (id,nombre, ruta,activo, prioridad, fechaInicio, fechaFin, badge, image) =>{
    var Token = convertSHA()
    const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
    let formData = new FormData();
  
    if (image == '') {
      image = '-1'
    }
    else {
      formData.append('image', image);
    }
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            }); 
          await instance.put(`/HealthCampaigns/${id}?token=${Token}&nombre=${nombre}
                                &ruta=${ruta}&prioridad=${prioridad}&activo=${activo}
                                &fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&badge=${badge}`, formData, config ).then((res => {
              dispatch({
                  type: UPDATE_HEALTH_CAMPAIGN,
                  data: res.data
                  
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  }

  export const deleteHealthCampaigns = (id,ruta) =>{
    var Token = convertSHA()
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            }); 
          await instance.delete(`/HealthCampaigns/${id}?image=${ruta}&token=${Token}` ).then((res => {
              dispatch({
                  type: DELETE_HEALTH_CAMPAIGN,
                  data: res.data 
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  }

  export const addImage = ( image) => {
    var Token = convertSHA()
    const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
    let formData = new FormData();
  
    if (image == '') {
      image = '-1'
    }
    else {
      formData.append('image', image);
    }
    return async dispatch => {
      dispatch({
        type: MEA_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await instance.post(`/HealthCampaigns?token=${Token}`, formData, config).then((res => {
        dispatch({
          type: MEA_ADD_IMAGE,
          data: res.data
        });
        //console.log(res);
        //console.log(res.data);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }

    
    
    export const getImage = ( imageName) => {
    var Token = convertSHA()
      return async dispatch => {
      dispatch({
        type: MEA_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await instance.get(`/HealthCampaigns?imgName=${imageName}&token=${Token}`).then((res => {
        dispatch({
          type: MEA_GET_IMAGE,
          data: res.data
        });
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }

  export const getPrueba = () =>{
    var Token = convertSHA()
    return async dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/diagnosticos/pruebadeApi`).then((res => {
        dispatch({
          type: MEA_PRUEBA,
          data: res.data
        })
      })).catch(function(error){
        console.log("Error", error);
      })
    }
  }

  export const getRequestType = (build) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/TipoSolicitud?token=${Token}&edificio=${build}`).then((res => {
          dispatch({
              type: MEA_GET_REQUEST_TYPE,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getAllEmployeesSiis = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Personal?token=${Token}&id=${badge}`).then((res => {
          dispatch({
              type: MEA_GET_EMPLOYEES_SIIS,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  
  export const getAllCoachEmployeesSiis = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Personal?token=${Token}&coachBadge=${badge}`).then((res => {
          dispatch({
              type: MEA_GET_EMPLOYEES_SIIS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  
  export const getOneEmployeeSiis = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/Personal?token=${Token}&badge=${badge}`).then((res => {
          dispatch({
              type: MEA_GET_ONE_EMPLOYEE_SIIS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getAllAreaCuenta = () => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/AreaCuenta?token=${Token}`).then((res => {
          dispatch({
              type: MEA_GET_AREA_CUENTA,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  

  export const getAllSelfManagment = (badge,estado, fecha) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/AutogestionCita?token=${Token}&badge=${badge}&estado=${estado}&fecha=${fecha}`).then((res => {
          dispatch({
              type: MEA_ALL_SELF_MANAGEMENTS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };   

  export const getAllCoachManagment = (coach) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/AutogestionCita?token=${Token}&coach=${coach}`).then((res => {
          dispatch({
              type: MEA_ALL_SELF_MANAGEMENTS,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  }; 

  export const getSelfManagment = (id) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/AutogestionCita?token=${Token}&id=${id}`).then((res => {
          dispatch({
              type: MEA_GET_SELF_MANAGEMENT,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const habilitarRegistroAutogestion = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/AutogestionCita?token=${Token}&badge=${badge}`).then((res => {
          dispatch({
              type: MEA_HABILITAR_CITA_AUTOGESTION,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const habilitarRegistroCita = (badge) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/CitaS?token=${Token}&badge=${badge}`).then((res => {
          dispatch({
              type: MEA_HABILITAR_CITA,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  
  export const sendEmail = (badge,estadoCita,infoCita) => {
    var Token = convertSHA();
    return async  dispatch =>{
      dispatch({
        type: MEA_LOADING
      });
      await instance.get(`/AutogestionCita?token=${Token}&badge=${badge}&estadoCita=${estadoCita}&infoCita=${infoCita}`).then((res => {
          dispatch({
              type: MEA_SEND_EMAIL,
              data: res.data
              });
        //console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const addSelfManagment= (badge,coach, build, area, tipo_solicitud, motivo, hora_entrada, hora_salida, hora_almuerzo, usuario,telefono) =>{
    var Token = convertSHA()
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          await instance.post(`/AutogestionCita?token=${Token}&badge=${badge}&build=${build}
                                &area=${area}&tipo_solicitud=${tipo_solicitud}&motivo=${motivo}&hora_entrada=${hora_entrada}
                                &hora_salida=${hora_salida}&hora_almuerzo=${hora_almuerzo}&usuario=${usuario}&telefono=${telefono}&coach=${coach}` ).then((res => {
              dispatch({
                  type: MEA_ADD_SELF_MANAGEMENT,
                  data: res.data
                  
              });
              
          })).catch(function(error){
            console.log("Error", error);
          });
      }
  } 
  
  export const updateSelfManagment= (idCita,  badge, medico,  building,  observaciones,  estado,  rechazo,  fechaCita,  fechaCreacion) =>{
    var Token = convertSHA()
    console.log(`/AutogestionCita?token=${Token}&idCita=${idCita}&badge=${badge}&medico=${medico}&building=${building}
    &observaciones=${observaciones}&estado=${estado}&rechazo=${rechazo}
    &fechaCita=${fechaCita}&fechaCreacion=${fechaCreacion}`)
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          await instance.post(`/AutogestionCita?token=${Token}&idCita=${idCita}&badge=${badge}&medico=${medico}&building=${building}
                                &observaciones=${observaciones}&estado=${estado}&rechazo=${rechazo}
                                &fechaCita=${fechaCita}&fechaCreacion=${fechaCreacion}`).then((res => {
              dispatch({
                  type: MEA_UPDATE_SELF_APPOIMENT,
                  data: res.data
              });
              //console.log("Resp", res.data);

          })).catch(function(error){
            console.log("Error", error);
          });
      }
  } 
  
    
  export const getEdificio= (badge) =>{
    var Token = convertSHA()
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          await instance.get(`/Edificios?token=${Token}&badgeUser=${badge}`).then((res => {
              dispatch({
                  type: MEA_GET_BUILDING,
                  data: res.data
              });
              //console.log("Resp", res.data);

          })).catch(function(error){
            console.log("Error", error);
          });
      }
  } 

  export const updateActivoEdificio= (building,  abierto) =>{
    var Token = convertSHA()
       return async dispatch => {
          dispatch({
              type: MEA_LOADING
            });
          await instance.post(`/Edificios?token=${Token}&edificio=${building}&abierto=${abierto}`).then((res => {
              dispatch({
                  type: MEA_UPDATE_OPEN_BUILDING,
                  data: res.data
              });
              //console.log("Resp", res.data);

          })).catch(function(error){
            console.log("Error", error);
          });
      }
  } 